import { CompetitorWrapper } from './styled';

export const CompetitorSkeleton = () => {
  return (
    <CompetitorWrapper data-cy-id="competitor-skeleton" disabled>
      <div className="p-4">
        <div className="relative w-full min-w-x6">
          <div className="bones relative w-full rounded-full pb-[100%]" />
        </div>
        <div className="flex flex-col gap-y-1.5 pt-2">
          <div className="bones text-sm">&nbsp;</div>
          <div className="text-xs">
            <div className="bones">&nbsp;</div>
            <div className="bones opacity-50">&nbsp;</div>
          </div>
        </div>
      </div>
    </CompetitorWrapper>
  );
};
